import styled, { createGlobalStyle } from 'styled-components';

export const Content = styled.div`
  .ocorrencia-badge {
    background: ${(props) => props.theme.$gray100};
    border: 1px solid ${(props) => props.theme.$gray300};
    color: ${(props) => props.theme.$gray700};
    font-weight: 500;
  }

  .ocorrencia-ia {
    color: ${(props) => props.theme.$success};
    font-size: 13px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
      vertical-align: text-bottom;
    }
  }

  .ocorrencia-resumo {
    color: ${(props) => props.theme.$gray700};
    white-space: pre-line;

    .btn-link {
      font-size: inherit;
    }
  }

  .ocorrencia-dialogo {
    border-left: 2px solid ${(props) => props.theme.$gray300};
    padding-left: 12px;
    font-size: 13px;
  }
`;

export const ModalLayer = createGlobalStyle`
  .hiring-history-info-backdrop {
    z-index: 3000000005;
  }

  .hiring-history-info-modal {
    z-index: 3000000006;

    .card p {
      white-space: pre-line;
    }
  }
`;
